import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { amiGet, amiPost, Card, Loading, StatusRow, errMsg } from "@/lib/ami";

const LIMIT_LABELS = {
  max_margin_pct_of_equity: ["Max. Margin pro Position", (v) => `${v} % des Kapitals`],
  max_leverage: ["Max. Hebel", (v) => `${v}x`],
  max_planned_risk_pct: ["Max. geplantes Risiko pro Trade", (v) => `${v} %`],
  max_open_positions: ["Offene Positionen", (v) => `max. ${v}`],
  stop_loss_required: ["Initialer Stop-Loss", (v) => (v ? "Pflicht" : "optional")],
  withdrawals: ["Auszahlungen", (v) => (v ? "erlaubt" : "niemals")],
};

export default function AmiSettings() {
  const s = useQuery({ queryKey: ["ami-settings"], queryFn: () => amiGet("/settings") });
  const st = useQuery({ queryKey: ["ami-status"], queryFn: () => amiGet("/status") });
  const tryLive = () => amiPost("/live/activate").catch((e) => toast.error(errMsg(e)));
  if (s.isLoading) return <Loading />;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="ami-settings">
      <Card title="Betriebsmodus" testid="ami-modes">
        {s.data.modes.map((m) => (
          <StatusRow key={m.key} label={`${m.label} – ${m.desc}`} ok={m.key === s.data.mode} value={m.key === s.data.mode ? "aktiv" : `ab Phase ${m.from_phase}`} testid={`ami-mode-${m.key}`} />
        ))}
        <Button variant="secondary" className="mt-4" onClick={tryLive} data-testid="ami-live-activate">Live-Trading aktivieren</Button>
        <p className="mt-2 text-xs text-muted-foreground">Der Server lehnt die Aktivierung in Phase 1 ab und protokolliert den Versuch.</p>
      </Card>
      <Card title="Harte Risikolimits (Risk Engine, ab Phase 4 erzwungen)" testid="ami-limits">
        {Object.entries(s.data.risk_limits).map(([k, v]) => <StatusRow key={k} label={LIMIT_LABELS[k]?.[0] || k} value={LIMIT_LABELS[k]?.[1](v) ?? String(v)} ok />)}
      </Card>
      <Card title="Entwicklungsphasen" testid="ami-phases" className="lg:col-span-2">
        {(st.data?.phases || []).map((p) => <StatusRow key={p.n} label={`Phase ${p.n} · ${p.name}`} value={p.status} ok={p.status === "aktiv"} warn={p.status === "gesperrt"} />)}
      </Card>
    </div>
  );
}
